import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {
	return {
		loginWallWrapper: {
			[rooterMediaQuery.desktop]: {
				borderRadius : "1rem !important",
				aspectRatio  : props?.isReel ? theme?.other.isApple ? "unset" : "9/16" : "16/9",
				width        : props?.isReel ? theme?.other.isApple ? "calc( 80vh * 9/16 )" : "initial" : "initial"
			},
			height   : "100%",
			overflow : "hidden"
		},
		overlayOuter: {
			overflow : "hidden",
			height   : "100%",
			position : "relative"
		},
		wallBackground: {
			height    : "100%",
			objectFit : "contain"
		},
		overlayRoot: {
			[rooterMediaQuery.desktop]: {
				borderRadius: "1rem !important"
			},
			zIndex   : props?.zIndex || "100",
			overflow : "hidden"
		},
		btnText: {
		},
		btn: {
			[rooterMediaQuery.mobile]: {
				padding: "0.6rem 1.4rem !important"
			}
		},
		buyProButton: {
			background: theme.other.paletteNew.proGradient
		},
		overlayInner: {
			height         : "100%",
			width          : "100%",
			display        : "flex",
			alignItems     : "center",
			flexDirection  : "column",
			borderRadius   : "1rem",
			gap            : "1rem",
			justifyContent : "center"
		},
		text: {
			color    : theme.other.paletteNew.darkModeWhite80,
			fontSize : "1.6rem"
		},
		text2: {
			color      : theme.other.paletteNew.darkModeWhite80,
			fontSize   : "1.8rem",
			fontWeight : 500
		}
	};
} );
